import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { GDPR_CONSENT_PENDING_KEY } from '../constants/gdprConsent'

/**
 * `/gdpr-consent` deep link / 307 landing.
 * Redirects to dashboard and opens the consent modal there so page content
 * stays visible behind the overlay (same pattern as Send Email and other popups).
 */
export function GdprConsentPage() {
  const navigate = useNavigate()

  useEffect(() => {
    try {
      sessionStorage.setItem(GDPR_CONSENT_PENDING_KEY, '1')
    } catch {
      /* ignore */
    }
    navigate('/dashboard', { replace: true })
  }, [navigate])

  return null
}
